<template>
  <modal :show="show" @change="$emit('change', $event)" width="550">
    <template v-slot:header>
      <span>Уважаемый клиент!</span>
    </template>
    <template v-slot:main>
      <div v-if="!paySuccess" class="modal-info text-center mx-7">
        <span class="d-block my-5"
          >Вы будете переведены на платежную страницу ПАО «АК БАРС»<br />БАНК, где
          сможете скорректировать сумму и <strong>оплатить</strong></span
        >
     <!--   <div class="text-left commission ml-10 pl-10">
          <span class="fs-14"
            ><strong>Комиссия банка:</strong> <br /><strong>0</strong> % - по картам
            ПАО «АК БАРС» Банк <br /><strong>0,8</strong> % - по картам других
            банков
          </span>
        </div> -->
        <div class="mt-3">
          <v-btn
            @click="GetBankUrl()"
            class="orange-button mb-5"
            :loading="loading"
            >Далее
          </v-btn>
        </div>
        <div>
          <a
            class="d-block mt-4 mx-12 text-center"
            href="https://tatenergosbyt.ru/communal/how-pay/"
            >Прочие способы оплаты</a
          >
        </div>
      </div>
      <div v-if="paySuccess" class="modal-info text-center mx-7 mt-10">
        <span class="d-block my-5">
          Сервис оплаты временно недоступен. Пожалуйста, повторите попытку
          позже.
        </span>
        <v-btn @click="$emit('change', false)" class="orange-button mb-5 mt-5" :loading="loading"
          >Закрыть
        </v-btn>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../common/Modal";
import { mask } from "vue-the-mask";
import { mapGetters, mapState } from "vuex";
import { AxiosWrapper } from "@/assets/api/AxiosWrapper";

export default {
  name: "ModalPayment",
  directives: {
    mask,
  },
  components: {
    Modal,
  },
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    toPay: {
      required: true,
      type: [Number, String],
      default: 0,
    },
    personalAccount: {
      required: true,
      type: [Number, String],
      default: 0,
    },
    idAccount: {
      required: true,
      type: [String],
      default: '',
    },

    details: {
      required: false,
      type: Array,
    },
  },
  data: () => ({
    message: "",
    email: "",
    phone: "",
    sendTo: {
      email: false,
      phone: false,
    },
    paySuccess: false,
    loading: false,
    valid: false,
    phoneRules: [
      (v) => !!v || "Номер телефона",
      (v) =>
        /^\+7\(\d{3}\)\d{3}-\d{2}-\d{2}/.test(v) || "Введите корректный номер",
    ],
    emailRules: [
      (v) => !!v || "Введите e-mail",
      (v) =>
        /^[^'"\|`~{}\[\]\/()\\=,<>\s\t]+$/.test(v) ||
        "Введены недопустимые символы",
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(v) ||
        "Введите корректный e-mail",
    ],
  }),
  computed: {
    ...mapState("account", ["selectedAccount"]),
    ...mapGetters("account", ["userSettings"]),
    disabled() {
      if (this.sendTo.email) {
        return !!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(this.email);
      } else if (this.sendTo.phone) {
        return !!/^\+7\(\d{3}\)\d{3}-\d{2}-\d{2}/.test(this.phone);
      } else {
        return false;
      }
    },
  },
  methods: {
    GetBankUrl(testMode = false) {
      this.loading = true;
      let postData = {
        appVersion: 'LKFL',
        personalAccount: this.personalAccount,
        paySum: this.toPay,
        idAccount: this.idAccount
      };
        console.log(this.personalAccount);
        console.log(this.toPay);
      AxiosWrapper.postForGetBankUrl("GetBankComissionUrl", postData)
        .then((response) => {
          if (response.data.success) {
            // console.log(response.data)
            // return;
            window.open(response.data.url, "_top");
          } else {
            this.paySuccess = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    Close() {
      this.$router.push("/");
    },
    validate() {
    },
    telEncode(tel) {
      const encodedTel = "+" + tel.replace(/\D+/g, "");
      return encodedTel;
    },
  },
  created() {

  },
  watch: {

  },
  mounted() {
    this.validate();
  },
};
</script>

<style lang="scss">
.modal-info {
  min-height: 200px;
  //display: flex;
  //flex-direction: column;

  &__message {
    margin: auto;
  }
}

.orange--checkbox {
  color: green !important;

  .accent--text {
    i {
      color: green !important;
    }
  }

  .v-application .accent--text {
    color: green !important;
  }
}

.modalPayment__form-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  width: 100%;

  .modalPayment__form-checkbox {
    position: relative;
    height: max-content;
    padding: 5px 0 0 0;
  }

  .modalPayment__form-field {
    position: relative;
    width: calc(100% - 32px);
    height: max-content;
  }

  .commission {
    margin-left: 2110px;
    padding-left: 1000px;
  }
}
